module.exports = __webpack_public_path__ + "static/media/Olivia Kitchen (7).cbf08981.jpg";